var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4993 19.2695L8.66602 13.4362L10.2993 11.7445L13.3327 14.7779V5.26953H15.666V14.7779L18.6993 11.7445L20.3327 13.4362L14.4993 19.2695ZM7.49935 23.9362C6.85768 23.9362 6.30857 23.7079 5.85202 23.2514C5.39546 22.7948 5.16679 22.2453 5.16602 21.6029V18.1029H7.49935V21.6029H21.4993V18.1029H23.8327V21.6029C23.8327 22.2445 23.6044 22.794 23.1478 23.2514C22.6913 23.7087 22.1418 23.937 21.4993 23.9362H7.49935Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7306d15ac1be5fb1168eed31f9f10115.svg";
export { ForwardRef as ReactComponent };